import React from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { useLanguage } from '../../contexts/LanguageContext';

const spinIcon = (
  <LoadingOutlined style={{ fontSize: 40, color: '#0e9191' }} spin />
);

/**
 * Full-screen translucent overlay loader.
 * Sits at z-index 9999 so it always covers the active view.
 */
const Loader = () => {
  const { t } = useLanguage();

  return (
    <div
      aria-label={t('status_loading')}
      role="status"
      style={{
        position: 'fixed',
        inset: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: 'rgba(255, 255, 255, 0.72)',
        backdropFilter: 'blur(2px)',
        WebkitBackdropFilter: 'blur(2px)',
        zIndex: 9999,
      }}
    >
      <Spin indicator={spinIcon} />
      <span style={{ marginTop: 12, fontSize: 13, color: '#6b7280', letterSpacing: '0.01em' }}>
        {t('status_loading')}…
      </span>
    </div>
  );
};

export default Loader;
